module.exports = __webpack_public_path__ + "media/images/weather/86_day_g-b4ba33c5ebe42be1d620c3ccac6dc455.png";